export const getTasks = state => state.todos;
